import React from "react";

export default function Slider({ label, value, onChange }) {
  return (
    <div className="rounded-2xl border border-gray-100 dark:border-slate-800 bg-white dark:bg-slate-900 p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="text-sm font-semibold text-gray-900 dark:text-slate-100">{label}</div>
        <div className="text-sm font-semibold text-indigo-600 dark:text-indigo-400">{value}%</div>
      </div>
      <input
        type="range"
        min={0}
        max={100}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="mt-3 w-full accent-indigo-600"
      />
      <div className="mt-2 flex items-center justify-between text-xs text-gray-500 dark:text-slate-500">
        <span>0</span><span>100</span>
      </div>
    </div>
  );
}
